import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import { getAll } from './selectors';
import Title from '../Title';
import List from './components/List';
import * as shapes from '../shapes';
import categoriesProvider from './hoc/categoriesProvider';
import { notBarberAndCanModifyProducts } from '../../common/helpers/users';


const ListContainer = ({ canModifyProducts, items, baseUrl }) => (
  <div>
    <Title>Categories</Title>
    <List canModifyProducts={canModifyProducts} items={items} baseUrl={baseUrl} />
  </div>
);

ListContainer.propTypes = {
  canModifyProducts: PropTypes.bool.isRequired,
  items: shapes.categories.isRequired,
  baseUrl: shapes.url.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  canModifyProducts: notBarberAndCanModifyProducts(state),
  items: getAll(state),
  baseUrl: ownProps.location.pathname,
});

export default compose(
  withRouter,
  categoriesProvider,
  connect(mapStateToProps)
)(ListContainer);
